import { ETheme, EVariant } from '../types';
var _WHITE = [EVariant.B, EVariant.C, EVariant.D];
export var getInternalTheme = function getInternalTheme(variant) {
  return _WHITE.includes(variant) ? ETheme.Light : ETheme.Dark;
};